import { V3Models } from "@istari/istari-client";

import { Transformation, TransformationKind } from "~/secure-connections/model/transformation";

// Exhaustive switch so adding a new SDK literal surfaces as a compile error
// instead of silently falling through as "unknown".
export function toTransformationKind(dto: V3Models.RemoteTransformationTypeDto): TransformationKind {
  switch (dto) {
    case "add_control_tag_with_id":
    case "remove_control_tag_with_id":
    case "map_control_tag_with_id":
      return dto;
  }
}

export function toTransformation(dto: V3Models.RemoteTransformationDto): Transformation {
  return {
    id: dto.id,
    fieldType: toTransformationKind(dto.fieldType),
    predicate: dto.predicate ?? null,
    value: dto.value ?? null,
    description: dto.description,
  };
}
